import { render, staticRenderFns } from "./pc-upload.vue?vue&type=template&id=31e7acde&scoped=true&"
import script from "./pc-upload.vue?vue&type=script&lang=ts&"
export * from "./pc-upload.vue?vue&type=script&lang=ts&"
import style0 from "./pc-upload.vue?vue&type=style&index=0&id=31e7acde&lang=less&scoped=true&"
import style1 from "./pc-upload.vue?vue&type=style&index=1&id=31e7acde&lang=less&scoped=true&"
import style2 from "./pc-upload.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e7acde",
  null
  
)

export default component.exports